export default "__VITE_ASSET__C5A0N3m0__"